// Registrační seznam agend modulu Columbus Planner — konzumuje ho centrální registr native agend
// (`app/router/nativeAgendaRegistry`) pro globální registraci v kernelu (agendy nemají vlastní route).

import type { AgendaRegistration } from '@/shared/navigation';

import { columbusAgenda } from './columbusAgenda';
import { columbusDetailAgenda } from './columbusDetailAgenda';
import { ColumbusShellPage } from './ColumbusShellPage';
import { ColumbusDetailPage } from './ColumbusDetailPage';
import { COLUMBUS_PERMISSION } from './permissions';

/** Agendy slice Columbus Planner (route `/columbus-planner`) — root list-detail + detail overlay. */
export const columbusAgendas: AgendaRegistration[] = [
  { agenda: columbusAgenda, component: ColumbusShellPage, permission: COLUMBUS_PERMISSION },
  { agenda: columbusDetailAgenda, component: ColumbusDetailPage, permission: COLUMBUS_PERMISSION },
];
